import { render, staticRenderFns } from "./ClinicalPractice.vue?vue&type=template&id=52d87b05&scoped=true"
import script from "./ClinicalPractice.vue?vue&type=script&lang=js"
export * from "./ClinicalPractice.vue?vue&type=script&lang=js"
import style0 from "./ClinicalPractice.vue?vue&type=style&index=0&id=52d87b05&prod&scoped=true&lang=css"
import style1 from "./ClinicalPractice.vue?vue&type=style&index=1&id=52d87b05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d87b05",
  null
  
)

export default component.exports